import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faList, faSortAmountDown, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button, Dropdown, ListDivider, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_ListModeButton } from '../../../../design/buttons/S_ListModeButton';
import { nameOf } from '../../../helpers/object.helpers';
import { ListViewMode } from '../../user/user.store';
import { IAttachment } from '../attachments.store';

library.add(faSortAmountDown, faTh, faList, faDownload);

interface IProps {
  viewMode: ListViewMode;
  orderBy: string;
  orderDirection: string;
  onViewModeChange: (mode: ListViewMode) => Promise<void>;
  onOrderByChange: (order: string) => Promise<void>;
  onOrderDirectionChange: (direction: string) => Promise<void>;
}

export const AttachmentsListControls = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <>
      <Dropdown>
        <MenuButton
          slots={{ root: Button }}
          slotProps={{ root: { variant: 'outlined', color: 'primary' } }}
        >
          <FontAwesomeIcon icon={faSortAmountDown} />
        </MenuButton>
        <Menu>
          <MenuItem
            onClick={(): void => {
              void props.onOrderByChange(nameOf<IAttachment>('name'));
            }}
            selected={props.orderBy === nameOf<IAttachment>('name')}
          >
            {t('name')}
          </MenuItem>
          <MenuItem
            onClick={(): void => {
              void props.onOrderByChange(nameOf<IAttachment>('createdDate'));
            }}
            selected={props.orderBy === nameOf<IAttachment>('createdDate')}
          >
            {t('createdDate')}
          </MenuItem>
          <MenuItem
            onClick={(): void => {
              void props.onOrderByChange(nameOf<IAttachment>('modifiedDate'));
            }}
            selected={props.orderBy === nameOf<IAttachment>('modifiedDate')}
          >
            {t('modified_date')}
          </MenuItem>
          <MenuItem
            onClick={(): void => {
              void props.onOrderByChange(nameOf<IAttachment>('author'));
            }}
            selected={props.orderBy === nameOf<IAttachment>('author')}
          >
            {t('author')}
          </MenuItem>
          <MenuItem
            onClick={(): void => {
              void props.onOrderByChange(nameOf<IAttachment>('size'));
            }}
            selected={props.orderBy === nameOf<IAttachment>('size')}
          >
            {t('size')}
          </MenuItem>
          <ListDivider />
          <MenuItem
            onClick={(): void => {
              void props.onOrderDirectionChange('ASC');
            }}
            selected={props.orderDirection.toUpperCase() === 'ASC'}
          >
            {t('ascending')}
          </MenuItem>
          <MenuItem
            onClick={(): void => {
              void props.onOrderDirectionChange('DESC');
            }}
            selected={props.orderDirection.toUpperCase() === 'DESC'}
          >
            {t('descending')}
          </MenuItem>
        </Menu>
      </Dropdown>
      <S_ListModeButton
        viewMode={props.viewMode}
        onChange={props.onViewModeChange}
      />
    </>
  );
});
